/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCountryEnum } from './addressCountryEnum';
import { AddressTypeEnum } from './addressTypeEnum';
import { BlankEnum } from './blankEnum';
import { NullEnum } from './nullEnum';

export interface ChildProfileAddressUpdate { 
    /**
     * If provided, the address will be updated, otherwise created.
     */
    id?: string;
    addressType: AddressTypeEnum;
    catchment?: boolean;
    streetAndHouseNumber?: string;
    city?: string;
    postalCode?: string;
    country: AddressCountryEnum | BlankEnum | NullEnum;
    district?: string;
}